module.exports = __webpack_public_path__ + "assets/59d19a33e20e4189bde38ae47aa08416.mp3";